import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';

import ContentArtesFacil from './ContentArtesFacil';

const ArtesFacil = () => {
  return (
    <>
      <HeaderApp />
      <ContentArtesFacil baseUrl="/artes-prontas" />
      <Bottom />
    </>
  );
};

export default ArtesFacil;
